// Angular
import {Component, HostBinding, OnInit, Input} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {TranslationService} from '../../../../../provider/translation.service';

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

@Component({
  selector: 'kt-language-selector',
  templateUrl: './language-selector.component.html',
})
export class LanguageSelectorComponent implements OnInit {
  @HostBinding('class') classes = '';
  @Input() iconType: '' | 'brand';

  language: LanguageFlag;
  languages: LanguageFlag[] = [
    {
      lang: 'tr',
      name: 'Türkçe',
      flag: './assets/media/flags/006-turkey.svg'
    },
    {
      lang: 'en',
      name: 'English',
      flag: './assets/media/flags/012-uk.svg'
    },
    {
      lang: 'ru',
      name: 'Russian',
      flag: './assets/media/flags/013-russia.svg'
    },
    {
      lang: 'es',
      name: 'Espanol',
      flag: './assets/media/flags/016-spain.svg'
    },
    {
      lang: 'de',
      name: 'German',
      flag: './assets/media/flags/017-germany.svg'
    },
  ];

  constructor(private translationService: TranslationService,
              private router: Router) {
  }

  ngOnInit() {
    this.setSelectedLanguage();
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(event => {
        this.setSelectedLanguage();
      });
  }

  setLanguage(lang) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
    this.translationService.setLanguage(lang);
  }

  setSelectedLanguage(): any {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }
}
